<template>
  <el-form label-position="top" :inline="true">
    <slot name="admin-extension"></slot>
    <TimeSearch
        ref="timeSearch"
        :month="true"
        :show-last-month="true"
    />

    <el-form-item label="Группировка">
      <el-select v-model="detailType">
        <el-option value="days" label="По дням"/>
        <el-option value="daysRates" label="По дням и тарифам"/>
      </el-select>
    </el-form-item>

    <el-form-item label=" ">
      <el-button type="success" plain @click="getReport" :disabled="reportButtonDisabled" :loading="reportLoading">
        Применить
      </el-button>
    </el-form-item>
  </el-form>

  <div v-show="reportReady" style="margin-top: 50px">
    <TextLabel type="balance" period-type="onStartPreiod" :value="enterSaldo"/>
    <TextLabel type="overdraft" period-type="onStartPreiod" :value="enterOverdraft" v-show="hadOverdraft"/>

    <FinanceMovementReportTable :table-data="tableData" :description-visible="descriptionVisible"/>

    <TextLabel type="balance" period-type="onEndPeriod" :value="exitSaldo"/>
    <TextLabel type="overdraft" period-type="onEndPeriod" :value="exitOverdraft" v-show="hadOverdraft"/>
  </div>
</template>

<script>
import TimeSearch from "@shared/components/reports/time-search.component"
import FinanceMovementReportTable from "./table/movements-table.component"
import TextLabel from "./table/text-label.component"

export default {
  name: "FinanceMovementReport",
  components: {TimeSearch, FinanceMovementReportTable, TextLabel},
  props: {
    getReportUrl: String,
    mutateParams: {
      type: Function,
      default: p => p
    },
    reportButtonDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hadOverdraft() {
      return this.tableData.some(v => v.overdraft > 0)
    }
  },
  methods: {
    async getReport() {
      this.reportReady = false
      this.reportLoading = true
      let dateFilter = this.$refs.timeSearch.getDateTimeFilter()
      let params = this.mutateParams({
        month: dateFilter.from.format("DD.MM.YYYY"),
        group: this.detailType
      })
      let resp = await this.axios.get(this.getReportUrl, {params}).catch(console.error)

      this.descriptionVisible = this.detailType === "daysRates"
      this.tableData = resp.data.records.sort((r1, r2) => r1.cat_m - r2.cat_m)
      let enterOp = resp.data.firstMonthOp ? resp.data.firstMonthOp : resp.data.lastEverOp
      if (resp.data.firstMonthOp) {
        if (enterOp.direction === 0) enterOp.balance = Number(enterOp.balance) + Number(enterOp.summ)
        else enterOp.balance = Number(enterOp.balance) - Number(enterOp.summ)
      }

      let exitOp = resp.data.lastMonthOp ? resp.data.lastMonthOp : resp.data.lastEverOp
      if ((exitOp && exitOp.cat > dateFilter.from.endOf("month").valueOf()) || !exitOp) {
        exitOp = {balance: "0.00", overdraft: "0.00"}
      }

      if ((enterOp && enterOp.cat > dateFilter.from.valueOf()) || !enterOp) {
        enterOp = {balance: "0.00", overdraft: "0.00"}
      }
      // if (exitOp.direction === 0) exitOp.balance = Number(exitOp.balance) + Number(exitOp.summ)
      // else exitOp.balance = Number(exitOp.balance) - Number(exitOp.summ)

      this.enterSaldo = enterOp.balance || "0"
      this.enterOverdraft = enterOp.overdraft || "0"
      this.exitSaldo = exitOp.balance || "0"
      this.exitOverdraft = exitOp.overdraft || "0"
      this.reportReady = true
      this.reportLoading = false
    }
  },
  data() {
    return {
      reportLoading: false,
      reportReady: false,
      tableData: [],
      enterSaldo: 0,
      enterOverdraft: 0,
      exitSaldo: 0,
      exitOverdraft: 0,
      detailType: "days",
      descriptionVisible: false
    }
  }
}
</script>